import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@/styles/components/slider.css";
import { isTouchDevice } from "@/scripts/common/util";
import { gsap } from "gsap";

document.querySelectorAll(".blog-post-slider").forEach((el) => {
  const container = el.querySelector(".swiper");
  const slides = el.querySelectorAll(".swiper-slide");
  const expandFactor = 1.5;

  let activeSlide = null;

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: "auto",
    spaceBetween: 16,
    speed: 1000,
    slideToClickedSlide: true,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 16,
      },
      1024: {
        spaceBetween: 0,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);

  if (window.matchMedia("(min-width: 1024px)").matches && !isTouchDevice) {
    const settleContainer = (activeSlide) => {
      gsap.to(container, {
        x: () => {
          if (activeSlide === null) {
            return 0;
          }

          const rect = activeSlide.getBoundingClientRect();
          const offset = rect.width / expandFactor;

          if (rect.x + rect.width > window.innerWidth) {
            return offset * -1;
          }

          if (rect.x + 1.25 * rect.width > window.innerWidth) {
            return offset / -3;
          }

          return 0;
        },
        duration: 2,
      });
    };

    slides.forEach((slide) => {
      const overlay = slide.querySelector(".item-overlay");
      const screen = slide.querySelector(".item-screen");
      const image = slide.querySelector(".item-image");

      const timeline = gsap.timeline({
        paused: true,
        onComplete: () => {
          settleContainer(activeSlide);
        },
        onReverseComplete: () => {
          slide.style.height = null;
          settleContainer(activeSlide);
        },
      });

      timeline.to(overlay, { opacity: 0, duration: 0.3 });

      timeline.to(slide, { width: `${parseFloat(slide.offsetWidth) * expandFactor}px`, duration: 0.5 }, "<50%");
      timeline.to(
        image,
        {
          opacity: 0,
        },
        "<",
      );
      timeline.fromTo(
        screen,
        { opacity: 0, visibility: "invisible" },
        {
          opacity: 1,
          visibility: "visible",
          pointerEvents: "auto",
          duration: 0.3,
        },
        "<",
      );
      timeline.fromTo(
        Array.from(screen.querySelector(".item-screen-children").children),
        { opacity: 0, y: "20%" },
        { opacity: 1, duration: 0.4, y: 0, stagger: 0.2 },
      );

      slide.addEventListener("mouseenter", () => {
        activeSlide = slide;
        slide.style.height = `${slide.dataset.height}px`;
        timeline.play();
      });

      slide.addEventListener("mouseleave", async () => {
        activeSlide = null;
        timeline.timeScale(2).reverse();
      });
    });
  }
});

const observer = new ResizeObserver(() => {
  document.querySelectorAll(".blog-post-slider .swiper-slide").forEach((slide) => {
    slide.setAttribute("data-height", slide.offsetHeight);
  });
});

observer.observe(document.body);
